import React from 'react'
import './styles.css'

const Header = (props) => {
  return (
    <div className="header">
      <h1>Pomodoro timer</h1>
    </div>
  )
}

export default Header
